import Add from "@mui/icons-material/Add";
import { Box, Button, Stack, Typography } from "@mui/material";
import { ErrorDisplay } from "components/Forms/ErrorDisplay";
import { useState } from "react";
import { Controller } from "react-hook-form";
import { ReportsDataGrid } from "../components/ReportsDataGrid";
import { ReportsPickerDialog } from "../components/ReportsPickerDialog";
import { useCommunicationFormContext } from "../hooks/useCommunicationForm";

export const ReportsStep = () => {
  const { control, watch, mode } = useCommunicationFormContext();
  const tenant = watch("tenant");
  const facilities = watch("facilities");

  const disabled = mode === "view" || !facilities.length;

  const [showReportPicker, setShowReportPicker] = useState(false);

  return (
    <Stack spacing={3}>
      <Typography variant="subtitle1">Reports</Typography>
      <Controller
        name="tierIIReports"
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <Box>
              <Button
                variant="text"
                size="small"
                startIcon={<Add />}
                disabled={disabled || !tenant}
                onClick={() => setShowReportPicker(true)}
              >
                Associate Reports
              </Button>
            </Box>

            {showReportPicker && (
              <ReportsPickerDialog
                tenantId={tenant?.id ?? ""}
                facilityIds={facilities.map((facility) => facility.id)}
                initialReportIds={value.map((report) => report.id)}
                close={() => setShowReportPicker(false)}
                saveReports={(reports) => {
                  onChange(reports);
                  setShowReportPicker(false);
                }}
              />
            )}

            {value.length > 0 && (
              <ReportsDataGrid
                tierIIReportIds={value.map((report) => report.id)}
                removeReport={
                  disabled
                    ? null
                    : (id) => {
                        onChange(value.filter((x) => x.id !== id));
                      }
                }
              />
            )}

            <ErrorDisplay error={error} />
          </>
        )}
      />
    </Stack>
  );
};
